import Schema, { optional, array } from 'AppReact/schema';

const label = { values: array('string'), keys: array('string'), component: optional('function') };

export default {
  buttonText: Schema('string', 'primitive', { defaultValue: '' }),
  value: Schema('string', 'primitive', { defaultValue: '' }),
  placeholder: Schema('string', 'primitive', { defaultValue: '' }),
  label: Schema(label, 'object', { defaultValue: { values: [], keys: [], component: null } }),
  buttonColor: Schema('string', 'primitive-nullable', { defaultValue: null }),
  disabledButton: Schema('boolean', 'primitive', { defaultValue: false })
}